import Service from './Service';

/**
 * 账户模块接口
 */
class AccountService extends Service {
    /**
     * 查询基本账户统计
     */
    getAccountStatistics(params) {
        return this.axios.get('api/pay/v1/tradeDetail/totalForMerchant', { params });
    }
    /**
     * 查询商家信息
     * @returns {*}
     */
    queryFranchiseeInfo() {
        return this.axios.get('api/pay/v1/access/currentFranchisee');
    }
    /****************中行子账户管理 *******************/

    /**
     * 查询子账户列表
     */
    getSubAccountList(params) {
        return this.axios.get('api/pay/v1/boc/subAccount', { params });
    }
    /**
     * 查询子账户列表统计数据
     */
    getSubAccountStatistics() {
        return this.axios.get('api/pay/v1/boc/subAccount/statistics');
    }
    /**
     * 订单管理列表
     */
    getOrderManageList(params) {
        return this.axios.get('api/pay/v1/boc/subAccount/order', {
            params
        });
    }
    /**
     *
     *订单管理详情
     */
    getOrderDetail(id) {
        return this.axios.get(`api/pay/v1/boc/subAccount/order/${id}`);
    }
    /**
     * 订单付款信息
     */
    getOrderPayInfo(params) {
        return this.axios.get('api/pay/v1/boc/subAccount/order/payment/list', {
            params
        });
    }
    /**
     * 子账户强制释放
     */
    forceRelease(id) {
        return this.axios.put(`api/pay/v1/boc/subAccount/release/${id}`);
    }
    /**
     * 获取商户列表
     */
    getMerchantList(params) {
        return this.axios.get(`api/pay/v1/boc/subAccount/merchants`, params);
    }
    /**
     * 新增子账号
     */
    addSubAccount(params) {
        return this.axios.post(`api/pay/v1/boc/subAccount`, params);
    }
    /**
     * 上架子账号
     */
    putOnSubAccount(params) {
        return this.axios.put(`api/pay/v1/boc/subAccount/enable`, params);
    }
    /**
     * 下架子账号
     */
    offSubAccount(params) {
        return this.axios.put(`api/pay/v1/boc/subAccount/disabled`, params);
    }
    /**
     * 子账户详情
     */
    getSubAccountDetail(id) {
        return this.axios.get(`api/pay/v1/boc/subAccount/${id}`);
    }
    /**
     * 历史订单
     */
    getHistoryList(params) {
        return this.axios.get(`api/pay/v1/boc/subAccount/order`, { params });
    }
    /**
     * 获取交易记录
     */
    getTransactionsList(params) {
        return this.axios.get(`api/pay/v1/boc/subAccount/deals`, { params });
    }
    /**
     * 操作记录
     */
    getSubAccountOpers(params) {
        return this.axios.get(`api/pay/v1/boc/subAccount/opers`, { params });
    }
    /**
     * 调账
     */
    subAccountTransfer(params) {
        return this.axios.post(`api/pay/v1/boc/subAccount/transfer`, params);
    }
    /**
     * 调账账户查询
     */
    subAccountSearch(params) {
        return this.axios.get(`api/pay/v1/boc/subAccount/detail`, { params });
    }
    /**
     * 子账户导入
     */
    subAccountImport(file) {
        const path = 'api/pay/v1/boc/subAccount/import';
        return this.importTemplate(file, path);
    }
    /**
     * 触发回调
     */
    triggerCallback(id) {
        return this.axios.get(`api/pay/v1/boc/subAccount/dms/callback/${id}`);
    }
}

const accountService = new AccountService();
export default accountService;
